import { createActionTypes } from 'components/utility/actions';
export const types = createActionTypes([
	'FETCH_TRIGGERS',
	'FETCH_TRIGGERS_SUCCESS',
	'FETCH_TRIGGERS_ERROR'
]);

export const fetchTriggers = () => ({ type: types.FETCH_TRIGGERS });

export const FETCH_FLOW = 'FETCH_FLOW';
export const FETCH_FLOW_SUCCESS = 'FETCH_FLOW_SUCCESS';
export const FETCH_FLOW_ERROR = 'FETCH_FLOW_ERROR';
export const fetchFlow = (flowId) => ({
	type: FETCH_FLOW, payload: { flowId }
});

export const FETCH_FLOW_NODE_HANDLERS = 'FETCH_FLOW_NODE_HANDLERS';
export const FETCH_FLOW_NODE_HANDLERS_SUCCESS = 'FETCH_FLOW_NODE_HANDLERS_SUCCESS';
export const FETCH_FLOW_NODE_HANDLERS_ERROR = 'FETCH_FLOW_NODE_HANDLERS_ERROR';
export const fetchFlowNodeHandlers = () => ({
	type: FETCH_FLOW_NODE_HANDLERS
});

export const VALIDATE_FLOW = 'VALIDATE_FLOW';
export const VALIDATE_FLOW_SUCCESS = 'VALIDATE_FLOW_SUCCESS';
export const VALIDATE_FLOW_ERROR = 'VALIDATE_FLOW_ERROR';
export const VALIDATE_FLOW_CANCEL = 'VALIDATE_FLOW_CANCEL';
export const validateFlow = (flow) => ({
	type: VALIDATE_FLOW, payload: { flow }
});

export const CLEAR_FLOW_VALIDATION = 'CLEAR_FLOW_VALIDATION';
export const clearFlowValidation = () => ({
	type: CLEAR_FLOW_VALIDATION
});

export const SAVE_FLOW = 'SAVE_FLOW';
export const SAVE_FLOW_SUCCESS = 'SAVE_FLOW_SUCCESS';
export const SAVE_FLOW_ERROR = 'SAVE_FLOW_ERROR';
export const SAVE_FLOW_COMPLETED = 'SAVE_FLOW_COMPLETED';
export const saveFlow = (flowId, flow, redirect) => ({
	type: SAVE_FLOW, payload: { flowId, flow, redirect }
});

export const NEW_ENDPOINT_FLOW = 'NEW_ENDPOINT_FLOW';
export const newEndpointFlow = (group, method, path) => ({
	type: NEW_ENDPOINT_FLOW, payload: { group, method, path }
});

export const NEW_UNBOUND_FLOW = 'NEW_UNBOUND_FLOW';
export const newUnboundFlow = (friendlyName) => ({
	type: NEW_UNBOUND_FLOW, payload: { friendlyName }
});

export const CREATE_ENDPOINT_FLOW = 'CREATE_ENDPOINT_FLOW';
export const createEndpointFlow = (
	endpointId,
	method,
	path,
	flowId,
	flow,
	redirect,
	projectName
) => ({
	type: CREATE_ENDPOINT_FLOW,
	payload: {
		endpointId,
		method,
		path,
		flowId,
		flow,
		flowType: 'endpoint',
		redirect,
		projectName
	}
});

export const CREATE_UNBOUND_FLOW = 'CREATE_UNBOUND_FLOW';
export const createUnboundFlow = (flowId, flow, redirect, projectName) => ({
	type: CREATE_UNBOUND_FLOW,
	payload: { flowId, flow, flowType: 'unbound', redirect, projectName }
});

export const DEBUG_FLOW_START = 'DEBUG_FLOW_START';
export const debugFlowStart = (flow, params, options) => ({
	type: DEBUG_FLOW_START, payload: { flow, params, options }
});
export const DEBUG_FLOW_RESPOND = 'DEBUG_FLOW_RESPOND';
export const debugFlowRespond = (payload) => ({
	type: DEBUG_FLOW_RESPOND, payload
});
export const DEBUG_FLOW_ERROR = 'DEBUG_FLOW_ERROR';
export const debugFlowError = (payload) => ({
	type: DEBUG_FLOW_ERROR, payload
});
export const DEBUG_FLOW_STOP = 'DEBUG_FLOW_STOP';
export const debugFlowStop = () => ({
	type: DEBUG_FLOW_STOP
});
export const DEBUG_FLOW_CLEAR = 'DEBUG_FLOW_CLEAR';
export const debugFlowClear = () => ({
	type: DEBUG_FLOW_CLEAR
});

export const FETCH_FLOW_TRIGGER_DEFINITIONS
	= 'FETCH_FLOW_TRIGGER_DEFINITIONS';
export const FETCH_FLOW_TRIGGER_DEFINITIONS_SUCCESS
	= 'FETCH_FLOW_TRIGGER_DEFINITIONS_SUCCESS';
export const FETCH_FLOW_TRIGGER_DEFINITIONS_ERROR
	= 'FETCH_FLOW_TRIGGER_DEFINITIONS_ERROR';
export const fetchFlowTriggerDefinitions = () => ({
	type: FETCH_FLOW_TRIGGER_DEFINITIONS
});

export const DELETE_FLOW = 'DELETE_FLOW';
export const DELETE_FLOW_ERROR = 'DELETE_FLOW_ERROR';
export const DELETE_FLOW_SUCCESS = 'DELETE_FLOW_SUCCESS';
export const deleteFlow = (flowId, redirect) => ({
	type: DELETE_FLOW, payload: { flowId, redirect }
});
